import {
  ref
} from 'vue'

import { generateUrl } from '@shared/util.js'

const selected = ref([])
const overSelected = ref(false)

export const usePropertiesEnquiry = () => {
  const enquiryPath = ref('')

  /**
   * 物件選択切り替え
   */
  const handleCheckProperty = (property, list) => {
    property.selected = property.selected ? false : true
    const set = new Set(selected.value)
    property.selected ? set.add(property.code) : set.delete(property.code)
    if (set.size >= 6) {
      property.selected = false
      overSelected.value = true
      return
    }
    selected.value = Array.from(set)

    if (selected.value.length > 0) {
      $('#fixed_contact_links').fadeIn();
      const url = generateUrl('enquiry', '')
      selected.value.forEach((code) => url.searchParams.append('properties[]', code))
      enquiryPath.value = url.toString()
    }
    else {
      $('#fixed_contact_links').fadeOut();
    }
  }

  return {
    // variables
    enquiryPath,
    overSelected,
    selected,
    // methods
    handleCheckProperty
  }
}
